import type * as React from 'react';
import { useIntl } from 'react-intl';

import type { VitaEducationExperienceFragment } from '@xing-com/crate-lebenslauf-graphql';

import {
  Container,
  ValueHighlighted,
  Description,
  Date,
} from './template-education-item-secondary.styled';
import { formatRangeDate } from './template-format-range-date';
import { Value } from './template-personal-data.styled';

export const TemplateEducationExperienceItemSecondary: React.FC<
  VitaEducationExperienceFragment & { $margin: string }
> = ({
  $margin,
  institution,
  startDate,
  endDate,
  courseOfStudy,
  isStillStudy,
  degree,
}) => {
  const intl = useIntl();
  const endDateValue = isStillStudy ? null : endDate;
  return (
    <Container $margin={$margin}>
      {institution ? <ValueHighlighted>{institution}</ValueHighlighted> : null}

      {startDate ? (
        <Date>
          {formatRangeDate(intl, startDate, endDateValue, {
            year: 'numeric',
          })}
        </Date>
      ) : null}
      {degree && <Value>{degree}</Value>}
      {courseOfStudy && <Description>{courseOfStudy}</Description>}
    </Container>
  );
};
